// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3AXaW","colMaxWidth":"Table_colMaxWidth__N5H71"};